import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import config from "../config";

export const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const [vendors, setVendors] = useState([]);
  const [pincode, setPincode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Load from localStorage on mount
  useEffect(() => {
    const savedVendors = localStorage.getItem("vendors");
    const savedParams = localStorage.getItem("searchParams");

    if (savedVendors) {
      setVendors(JSON.parse(savedVendors));
    }
    if (savedParams) {
      const { pincode: savedPin } = JSON.parse(savedParams);
      if (savedPin) setPincode(savedPin);
    }
  }, []);

  /**
   * Fetches vendors based on pincode and radius
   */
  const fetchVendors = async (radius = 20, pincodeOverride) => {
    setLoading(true);
    setError(null);

    // Determine which pincode to use (passed directly or from state)
    const targetPincode = pincodeOverride || pincode;

    if (!targetPincode || targetPincode.trim() === "") {
      setError("Please enter a valid pincode.");
      setLoading(false);
      return null;
    }
    try {
      // Dynamic URL using environment variable
      // Removed the hardcoded '?pincode=201301&radius=20'
      const response = await axios.get(`${config.API_BASE_URL}/customer/searchVendors`, {
        params: {
          pincode: targetPincode,
          radius: radius
        }
        
      });

      const vendorsData = response.data.data || [];
      
      // Update State
      setVendors(vendorsData);
      
      // Update LocalStorage for persistence
      localStorage.setItem("vendors", JSON.stringify(vendorsData));
      localStorage.setItem("searchParams", JSON.stringify({ pincode: targetPincode, radius }));

      setLoading(false);
      return response.data;
    } catch (err) {
      console.error("❌ Error fetching vendors:", err);
      const errorMsg = err.response?.data?.message || "Failed to fetch vendors.";
      setError(errorMsg);
      setLoading(false);
      return null;
    }
  };

  const clearVendors = () => {
    setVendors([]);
    setPincode("");
    localStorage.removeItem("vendors");
    localStorage.removeItem("searchParams");
  };

  return (
    <SearchContext.Provider
      value={{
        vendors,
        setVendors,
        fetchVendors,
        clearVendors,
        pincode,
        setPincode,
        loading,
        error,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};